import arrowImg from "../../../../picture/PlayLanguage.png";
import { useEffect, useRef, useState } from "react";

// values are objects {id, name}
const CustomSelectWithLabel = ({
  allValues,
  selectedValue,
  onSelectChange,
  label,
  disabled = false
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);
  const optionsRef = useRef(null);

  const handleOpen = () => {
    setIsOpen(!isOpen);
  };
  const handleSelect = (value) => {
    if (onSelectChange) onSelectChange(value);
    setIsOpen(false);
  };

  useEffect(() => {
    const rect = selectRef.current.getBoundingClientRect();
    optionsRef.current.style.width = rect.width + "px";

    function handleClickOutside(event) {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={selectRef} style={{ position: "relative" }}>
      <div
        style={{
          fontWeight: "bold",
          fontSize: "16px",
          marginBottom: "5px"
        }}
      >
        {label}
      </div>
      <div onClick={handleOpen} style={{ position: "relative" }}>
        <input
          type="text"
          value={selectedValue.name}
          readOnly
          disabled={disabled}
          style={{
            width: "100%",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: "16px",
            height: "40px",
            padding: "10px"
          }}
        />
        {!disabled && (
          <div
            style={{
              width: "30px",
              position: "absolute",
              right: "0px",
              top: "10px",
              backgroundColor: "transparent"
            }}
          >
            <img
              src={arrowImg}
              alt=""
              className="profile-select-item-img"
              style={{ transform: isOpen ? "rotate(-90deg)" : "rotate(90deg)" }}
            />
          </div>
        )}
      </div>
      <div
        ref={optionsRef}
        style={{
          position: "absolute",
          zIndex: "10",
          display: isOpen ? "block" : "none",
          boxShadow: "0px 5px 10px rgba(0, 0, 0, 0.15)"
        }}
      >
        {!disabled &&
          allValues.map((value, index) => (
            <div
              key={value.id}
              onClick={() => handleSelect(value)}
              style={{
                wordBreak: "break-word",
                padding: "5px 10px",
                borderBottom: "1px solid black",
                cursor: "pointer",
                backgroundColor:
                  value.id === selectedValue.id ? "lightgrey" : "white",
                display: "flex",
                alignItems: "center"
              }}
            >
              {value.name}
            </div>
          ))}
      </div>
    </div>
  );
};

export default CustomSelectWithLabel;
